import { SalesSummary } from "./focusDataModels/SalesSummary";
import { ManagerLogCommentItem } from "./ManagerLogComment.item";
import { User } from "./user.model";

export class ManagerLogPostItem {
	pk: string; //LOG_venueKey
	sk: string; //:createdDateTime.unix
	authorUserKey: string;
	created: string | Date;
	businessDate: Date;
	modified: string;
	tags: string[];
	subject: string;
	body: string;
	notifications: string[];
	attachmentKey: string[];
	deleted: boolean;
	salesSummary: SalesSummary;
	authorUser: User;
	notificationUsers: User[];

	managerLogComments: ManagerLogCommentItem[];

	public constructor(init?: Partial<ManagerLogPostItem>) {
		Object.assign(this, init);
	}
}
